import { Box, Button, Stack, Typography } from "@mui/material";
import { icons } from "assets/AssetHelper";
import { useThemePalette } from "common/hooks/theme_palette";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useTranslation } from "react-i18next";

export default function Header({
  title,
  children,
  deleteBtn = true,
  editBtn = true,
  setOpenDeleteModal,
  customNav,
}) {
  const { t } = useTranslation();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const { oliveGreen, red } = useThemePalette();
  const navigate = useNavigate();

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "stretch", md: "center" }}
      gap={2}
    >
      {title && (
        <Stack width={{ xs: "100%", md: "50%" }}>
          <Typography
            fontSize="32px"
            fontWeight="700"
            fontFamily="Cairo"
            gutterBottom
            sx={{ m: 0 }}
          >
            {title}
          </Typography>
        </Stack>
      )}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        width={{ xs: "100%", md: "auto" }}
        gap={2}
        justifyContent="end"
        alignItems={{ xs: "stretch", sm: "center" }}
      >
        {children}
        {deleteBtn && (
          <Button
            sx={{
              color: red,
              border: `1px solid ${red}`,
              padding: { xs: "8px 24px 8px 50px", md: "8px 97px" },
              position: "relative",
            }}
            onClick={(_) => setOpenDeleteModal(true)}
          >
            <Box
              component="img"
              src={icons.templateDeleteIcon}
              alt="edit icon"
              width="24px"
              height="24px"
              sx={{ position: "absolute", left: "20px" }}
            />
            {t("common.delete")}
          </Button>
        )}
        {editBtn && (
          <Button
            onClick={(_) => {
              customNav
                ? navigate("/edit-profile")
                : navigate(`?type=form&id=${id}`);
            }}
            variant="contained"
            sx={{
              py: 1,
              textTransform: "none",
              display: "flex",
              position: "relative",
              justifyContent: "space-between",
              backgroundColor: oliveGreen,
              "&:hover": {
                backgroundColor: oliveGreen,
              },
              padding: { xs: "8px 24px 8px 50px", md: "8px 97px" },
            }}
          >
            <Box
              component="img"
              src={icons.editWhite}
              alt="edit icon"
              width="24px"
              height="24px"
              sx={{ position: "absolute", left: "20px" }}
            />
            <Typography
              sx={{
                fontSize: "18px",
                fontFamily: "Cairo",
                fontWeight: "400",
              }}
            >
              {t("common.edit")}
            </Typography>
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
